import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export function EmergencyRequestModal({
  emergencyReason,
  setEmergencyReason,
  submittingRequest,
  onSubmit,
  onClose,
}) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="emergency-request-modal">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-600" />
            Request Emergency Access
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 text-sm text-amber-800">
          <p className="font-medium mb-1">Important:</p>
          <ul className="list-disc list-inside space-y-1 text-amber-700">
            <li>The vault owner will be notified immediately</li>
            <li>They have 72 hours to respond</li>
            <li>Reminders are sent at 24h and 48h</li>
            <li>Access is auto-granted if no response</li>
          </ul>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Request *</label>
            <textarea
              value={emergencyReason}
              onChange={(e) => setEmergencyReason(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows={4}
              placeholder="Please explain why you need emergency access to the vault documents..."
              required
              data-testid="emergency-reason-input"
            />
            <p className="text-xs text-gray-500 mt-1">This reason will be shared with the vault owner</p>
          </div>
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submittingRequest || !emergencyReason.trim()}
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              data-testid="submit-emergency-request-btn"
            >
              {submittingRequest ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
